import { cssPrefix } from '../../../../const/Constant';
import { XScreenZone } from './XScreenZone';

class XScreenBRZone extends XScreenZone {

  constructor() {
    super(`${cssPrefix}-x-screen-br-zone`);
  }

}

export {
  XScreenBRZone,
};
